const MOBILE_NUMBER_PATTERN = /^09[0-9]{9}$/
const ACCEPTED_08_PREFIX = [
  // based on https://github.com/0xbitx/PH_Mobile_Number_Prefixes as of May 7, 2025
  '0817',
  '0813',
  '0811',
  '0895',
  '0896',
  '0897',
  '0898',
]
const matchString = ACCEPTED_08_PREFIX.join('|')
const MOBILE_NUMBER_08_PATTERN = new RegExp(`^(?=${matchString})[0-9]{11}$`)

const isMobileNumber = maybeMobileNumber =>
  typeof maybeMobileNumber === 'string' &&
  (MOBILE_NUMBER_PATTERN.test(maybeMobileNumber) ||
    MOBILE_NUMBER_08_PATTERN.test(maybeMobileNumber))

export default isMobileNumber
